<section class="pb-4 pb-lg-5" *ngIf="recentlyViewedProducts?.length > 0">
    <div class="tab-content my-3 my-md-4" id="pills-tabContent">
        <div class="container-fluid px-0 px-lg-2">
            <div class="d-flex justify-content-between align-items-center pb-3 pb-lg-1 mb-0">
                <p class="recently-view-title mb-0 ps-2 ps-lg-4">Recently Viewed</p>
                <div class="brand-header" *ngIf="recentlyViewedProducts?.length > visibleItems">
                    <div class="carousel-controls d-flex gap-2">
                        <button type="button" (click)="prevSlide()">
                            <img [src]="commonImagePath+'previous-img.webp'" alt="Previous" loading="lazy" />
                        </button>
                        <button type="button" (click)="nextSlide()">
                            <img [src]="commonImagePath+'next_img.webp'" alt="Next" loading="lazy" />
                        </button>
                    </div>
                </div>
            </div>
            <div id="best-pan1" class="slider-wrapper" role="tabpanel" aria-labelledby="best-pan1-tab" tabindex="0"  (touchstart)="onTouchStart($event)"
     (touchend)="onTouchEnd($event)">
                <div class="slider-inner"
                    [ngStyle]="{ 'transform': 'translateX(-' + currentIndex * (100 / visibleItems) + '%)' }">
                    <div class="col-6 col-md-4 col-lg-3 w-20 pb-0 pb-md-0 p-1 p-md-2 mt-0 mt-md-4 me-lg-1 slider"
                        *ngFor="let product of recentlyViewedProducts">
                        <div class="product-wrap">
                            <div class="product-border position-relative">
                                <div class="blue-print-logo" *ngIf="product?.brand?.small_image">
                                    <img [src]="cdnImagePath + product?.brand?.small_image" [alt]="product?.brand?.name"
                                        class="img-fluid" loading="lazy" />
                                </div>
                                <ng-container *ngIf="getProductPromotion(product) as promo">
                                    <div class="discount-txt" [ngSwitch]="promo.promotionType">
                                        <ng-container *ngSwitchCase="'percentage_discount'">
                                            {{ promo.promotionDescription }} - {{ promo.promotionDiscount }}% OFF
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'discount_flat_rate'">
                                            {{ promo.promotionDescription }} - ${{ promo.promotionDiscount }} OFF
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <div class="review-img-wrap">
                                    <img [src]="cdnImagePath + product?.product_photo?.large_image" width="180"
                                        height="100" [alt]="product?.name" [title]="product?.name"
                                        (click)="productRedirection(product)" (error)="onProductImageError($event)"
                                        loading="lazy" />
                                </div>
                            </div>
                            <div class="product-title mt-3">
                                <h2 [title]="product?.name" class="mb-1 cursor-pointer recenty-truckate"
                                    (click)="productRedirection(product)">
                                    {{ product?.name | removeBackslash}}
                                </h2>
                                <p class="mt-2 mb-1 item-description">
                                    {{ product?.short_description | truncateHtml:68 }}
                                </p>
                                <!-- <p *ngIf="!hideSubtitle" class="mt-2 mb-1 short-txt"
                                    [innerHTML]="getProductSubtitle(product) | truncateHtml:35">
                                </p> -->
                                <span class="SBFKE-txt">Part# {{product?.product_variations[0]?.sku}}</span>
                            </div>
                            <div class="mt-1 d-flex align-items-center">
                                <div class="rating">
                                    <ng-container *ngIf="(product.avgRating | starpipe:'fullStar') > 0">
                                        <ng-container
                                            *ngFor="let fullstar of (product.avgRating | starpipe:'fullStar': true)">
                                            <i class="fas fa-star star full fullStar fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(product.avgRating | starpipe:'halfStar') > 0">
                                        <ng-container
                                            *ngFor="let halfstar of (product.avgRating | starpipe:'halfStar': true)">
                                            <i class="fas fa-star-half-alt half-star fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(product.avgRating | starpipe:'noStar') > 0">
                                        <ng-container
                                            *ngFor="let noStar of (product.avgRating | starpipe:'noStar': true)">
                                            <i class="fas fa-star star empty grey-star fa-sm"></i>
                                        </ng-container>
                                    </ng-container>
                                    <span class="review-txt">
                                        ({{ product.reviewsCount }} {{ product.reviewsCount > 1 ? 'reviews' : 'review'
                                        }})
                                    </span>
                                </div>
                            </div>
                            <div class="mt-2 max-h">
                                <ng-container *ngIf="getProductFinalPrice(product)?.finalPrice > 0">
                                    <ng-container *ngIf="product?.promotions; else noPromo">
                                        <p class="mb-0 price-txt" [ngClass]="product?.promotions && chTheme4 ? 'price-red-color' : 'price-regular-color'">
                                            {{ getProductFinalPrice(product).finalPrice || ' ' | customCurrency}}
                                        </p>
                                        <small class="text-decoration-line-through price-text">
                                            {{ getProductFinalPrice(product).originalPrice || ' ' | customCurrency}}
                                        </small>
                                    </ng-container>
                                    <ng-template #noPromo>
                                        <div class="">
                                            <p class="mb-0 price-txt">
                                                {{ getProductFinalPrice(product).originalPrice | customCurrency }}
                                            </p>
                                            <small *ngIf="getProductFinalPrice(product).showMsrp"
                                                class="text-decoration-line-through price-text">
                                                {{ getProductFinalPrice(product).msrpPrice | customCurrency }}
                                            </small>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </div>
                            <div class="mt-0 stock-info" *ngIf="!inventoryDisabled">
                                <ng-container *ngIf="product?.is_special === 'true'">
                                    <a class="stock-txt">Special Order</a>
                                </ng-container>
                                <ng-container *ngIf="product?.is_special === 'false'">
                                    <!-- Stock Info Karl -->
                                    <ng-container *ngIf="chTheme1; else nokarl">
                                        <ng-container *ngIf="getInventoryData(product) as inv">
                                            <ng-container
                                                *ngIf="getInventoryMessages(inv.qty, inv.isInStock, inv.warehouse, inv.karlsQty) as inventoryMessages">
                                                <ng-container
                                                    *ngIf="!inventoryMessages.showBackorder; else outOfStockBlock">
                                                    <p class="d-flex flex-column availability-recently">
                                                        <!-- Availability -->
                                                        <span class="fw-bold">
                                                            <span class="text-blue">
                                                                {{
                                                                inventoryMessages?.availabilityMsg?.split('
                                                                ').slice(0, 2).join(' ') }}
                                                            </span>
                                                            {{
                                                            inventoryMessages?.availabilityMsg?.split('
                                                            ').slice(2).join(' ') }}
                                                        </span>
                                                        <!-- Urgency -->
                                                        <span class="text-red fw-bold">
                                                            {{ inventoryMessages?.urgencyMsg }}
                                                        </span>
                                                        <!-- Pickup -->
                                                        <span class="fw-bold"
                                                            *ngIf="inventoryMessages?.pickupMsg === 'Local pickup not available'; else pickupAvailable1">
                                                            <span class="local-pickup">Local pickup</span>&nbsp;<span
                                                                class="fw-normal">not
                                                                available</span>
                                                        </span>
                                                        <ng-template #pickupAvailable1>
                                                            <span class="fw-bold"
                                                                [innerHTML]="getPickupMsgHtml(product)"></span>
                                                        </ng-template>
                                                    </p>
                                                </ng-container>
                                                <ng-template #outOfStockBlock>
                                                    <p class="d-flex flex-column availability-recently">
                                                        <!-- Availability -->
                                                        <span class="fw-bold">
                                                            {{ inventoryMessages?.availabilityMsg }}
                                                        </span>
                                                        <!-- Pickup -->
                                                        <span class="fw-bold"
                                                            *ngIf="inventoryMessages?.pickupMsg === 'Local pickup not available'; else pickupAvailable1">
                                                            <span class="local-pickup">Local pickup</span>&nbsp;<span
                                                                class="fw-normal">not
                                                                available</span>
                                                        </span>
                                                        <ng-template #pickupAvailable1>
                                                            <span class="fw-bold"
                                                                [innerHTML]="getPickupMsgHtml(product)"></span>
                                                        </ng-template>
                                                    </p>
                                                </ng-template>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <!-- Stock Info Other -->
                                    <ng-template #nokarl>
                                        <span class="stock-txt"
                                            [ngClass]="{ 'out-of-stock': +product?.product_variations?.[0]?.inventory_qty_on_hand <= 1 }">
                                            <ng-container
                                                *ngIf="+product?.product_variations?.[0]?.inventory_qty_on_hand > 0; else outOfStock">
                                                In Stock</ng-container>
                                            <ng-template #outOfStock>Call For Availability
                                                <a [href]="'tel:' + contact" class="text-danger text-decoration-none">
                                                    {{formatted_contact}}
                                                </a>
                                            </ng-template>
                                        </span>
                                    </ng-template>
                                </ng-container>
                            </div>
                            <div class="shipping-wrapper d-flex align-items-start gap-2 red-truck-wrapper">
                                <ng-container *ngIf="product?.is_shippable == 0">
                                    <img class="img-fluid red-truck"
                                        [src]="commonImagePath+'freeshipping_red_icon.webp'" loading="lazy" />
                                    <span class="shipping-wrap">Free Shipping</span>
                                </ng-container>
                            </div>
                            <div class="d-flex align-items-center gap-2  color-img-wrapper">
                                <img *ngFor="let color of product?.colors.slice(0,3)"
                                    [src]="cdnImagePath + color?.color_chip_img" [alt]="color?.color"
                                    class="img-fluid color-img cursor-pointer" loading="lazy"
                                    (click)="productRedirectionWithColor(product, color)" />
                                <ng-container *ngIf="product?.colors?.length > 3">
                                    <div class="black-plus d-flex justify-content-center align-items-center"
                                        (click)="productRedirection(product)">
                                        +
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Add/Checkout toggle -->
                            <div class="recently-btns">
                                <ng-container *ngIf="addToCartFlag[product?.product_key]">
                                    <ng-container
                                        *ngIf="product?.product_variations?.length <= 1 && getProductFinalPrice(product)?.finalPrice > 0; else contactusBtn">
                                        <ng-container *ngIf="addToCartButtons[product.product_variations[0]?.product_variation_key]; else checkoutBtn">
                                            <ng-container
                                                *ngIf="+product?.product_variations?.[0]?.inventory_qty_on_hand > 0 || inventoryDisabled; else outOfStockBtn">
                                                <button class="btn w-100  add-cart-btn" (click)="addToCart(product)">
                                                    ADD TO CART
                                                </button>
                                            </ng-container>
                                            <ng-template #outOfStockBtn>
                                                <button class="btn w-100  back-order-btn" (click)="addToCart(product)">
                                                    PLACE BACKORDER
                                                </button>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #checkoutBtn>
                                            <button [routerLink]="['/cart']" class="btn w-100  add-cart-btn" [disabled]="disableCheckoutButton">
                                                CHECKOUT NOW
                                            </button>
                                        </ng-template>
                                    </ng-container>
                                    <ng-template #contactusBtn>
                                        <button *ngIf="product?.product_variations?.length <= 1" class="btn w-100  cont-order-btn"
                                            (click)="onContactClick(product)">
                                            CONTACT US FOR BEST PRICING
                                        </button>
                                    </ng-template>
                                </ng-container>
                                <!-- VIEW PRODUCTS -->
                                <button *ngIf="product?.product_variations?.length > 1"
                                    class="btn w-100  view-product-btn" (click)="productRedirection(product)">
                                    VIEW PRODUCTS
                                </button>
                            </div>
                            <div class="d-flex gap-1 mt-1 cursor-pointer px-2 wishlist-recent">
                                <!-- <small class="compare-txt">
                                    <img [src]="commonImagePath +'check.webp'" class="img-fluid check-icon"
                                        loading="lazy" />
                                    Compare</small> -->
                                <div class="aff-recently-h"
                                    *ngIf="product?.affirm_eligible || product?.paypal_eligible">
                                    <ng-container *ngIf="getProductFinalPrice(product)?.finalPrice > 0">
                                        <small class="d-inline-block" *ngIf="product?.affirm_eligible">
                                            <app-affirm-widget [amount]="product?.promotions
                                    ? getProductFinalPrice(product).finalPrice * 100
                                    : getProductFinalPrice(product).originalPrice * 100">
                                            </app-affirm-widget>
                                        </small>
                                        <small class="d-inline-block" *ngIf="product?.paypal_eligible">
                                            <app-paypal-widget [amount]="product?.promotions
                                    ? getProductFinalPrice(product).finalPrice
                                    : getProductFinalPrice(product).originalPrice" [clientId]="paypalClientId">
                                            </app-paypal-widget>
                                        </small>
                                    </ng-container>
                                </div>
                                <!-- <img [src]="commonImagePath+'like_img_karls.png'" class="img-fluid heart-icon"
                                    (click)="openLoveItPopup(product)" loading="lazy" /> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>